// cultureSpecificMixin.js
export function GetSpecificCulture(culture) {
    if (culture == "dk") {
        return "da-dk";
    } else {
        return culture;
    }
}